<template>
  <ul class="c-playlist c-playlist--large c-playlist--dividers">
    <li class="c-playlist__item" v-if="isLoading">
      <div class="o-playlist__content">
        Bezig met laden...
      </div>
    </li>

    <HiddenTracks :count="numberOfHiddenTracks" v-if="!isLoading && !isSearching && numberOfHiddenTracks" />

    <li class="c-playlist__item" :key="track.id" v-for="track in tracks">
      <TrackListTrack :track=track></TrackListTrack>
    </li>

    <li class="c-playlist__item" v-if="!isLoading && isSearching && tracks.length == 0">
      <div class="o-playlist__content">
        Geen nummers gevonden voor zoekterm "{{query}}"
      </div>
    </li>
  </ul>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import TrackListTrack from './TrackListTrack';
import HiddenTracks from './HiddenTracks'

export default {
  name: 'TrackList',
  computed: {
    ...mapGetters({
      tracks: 'hitlist/displayedTracks',
      isSearching: 'hitlist/isSearching'
    }),
    ...mapState({
      query: state => state.hitlist.query,
      isLoading: state => state.hitlist.isLoading,
    }),
    numberOfHiddenTracks() {
      const {position} = (this.tracks[0] || {})
      if (position < 12 && position != 1) {
        return position - 1
      }

      return null;
    }
  },
  components: {
    HiddenTracks,
    TrackListTrack
  },
};
</script>
